import { render, staticRenderFns } from "./BpmModel.vue?vue&type=template&id=6ea1d523&scoped=true&"
import script from "./BpmModel.vue?vue&type=script&lang=js&"
export * from "./BpmModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea1d523",
  null
  
)

export default component.exports